import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useUser } from '../../contexts/AuthContext';
import { useUrlGenerator } from '../../contexts/RoutesContext';
import NotificationPanel from '../partials/NotificationPanel';

import styles from '../../../styles/notifications/notifications.module.scss';

const propTypes = {
    edition: PropTypes.shape({
        id: PropTypes.string,
        handle: PropTypes.string,
    }),
    className: PropTypes.string,
};

const defaultProps = {
    edition: null,
    className: null,
};

const PreviewEdition = ({ edition, className }) => {
    const user = useUser();
    const route = useUrlGenerator();

    if (edition === null || user === null) {
        return null;
    }

    const { id = null, handle = null, upcoming = false } = edition || {};

    return (
        <div
            className={classNames(styles.container, {
                [className]: className !== null,
            })}
        >
            <NotificationPanel
                className={classNames([styles.notification, styles.bottom])}
                href={`${route('home')}?preview_edition=0`}
                target="_self"
                external
                small
                active
                horizontal
                label={
                    <FormattedMessage
                        defaultMessage="Preview — Edition {year}"
                        description="Notification label"
                        values={{ year: handle }}
                    />
                }
                buttonLabel={
                    <FormattedMessage
                        defaultMessage="Go back to current edition"
                        description="Notification label"
                    />
                }
            >
                <span className={styles.label}>
                    {!upcoming ? (
                        <FormattedMessage
                            defaultMessage="Warning: you are previewing hidden films"
                            description="Notification label"
                        />
                    ) : null}
                </span>
                <a
                    className={styles.button}
                    href={`${route('home')}?preview_edition=${id}&show_all_films=${
                        upcoming ? 'true' : 'false'
                    }`}
                >
                    {upcoming ? (
                        <FormattedMessage
                            defaultMessage="Show full programming"
                            description="Notification label"
                        />
                    ) : (
                        <FormattedMessage
                            defaultMessage="Show visitor programming"
                            description="Notification label"
                        />
                    )}
                </a>
            </NotificationPanel>
        </div>
    );
};

PreviewEdition.propTypes = propTypes;
PreviewEdition.defaultProps = defaultProps;

export default PreviewEdition;
